import * as React from 'react';
import { useDispatch } from 'react-redux';
import * as Forms from '../../../../components/form-elements/_index';
import { ApiEndpoints } from '../../../../utils/app-constants';
import { AssetReference, DriverReference } from '../../../../transportation/models/trucks/truck-read';

interface IProps {
    deliveryServiceCenter   : string;
    driverChange            : any;
    tractorChange           : any;
    trailerChange           : any;
    driver                  : DriverReference|undefined;
    tractor                 : AssetReference|undefined;
    trailer                 : AssetReference|undefined;
    disable                 : boolean;
    disableTrailer          : boolean;
    showCompactUI           : boolean;
}

export const EditDeliveryAssets = (props: IProps) => {

    const dispatch = useDispatch();

    const onDriverChange = (e: any) => {
        props.driverChange(e);
    };

    const onTractorAssetChange = (e: any) => {
        props.tractorChange(e);
    };

    const onTrailerAssetChange = (e: any) => {
        props.trailerChange(e);
    };

    return <React.Fragment>
        <div className="row">
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-3" }>
                <Forms.AutoCompleteInput
                    id="edit-delivery-driver"
                    label="Driver"
                    onChange={onDriverChange}
                    dispatch={dispatch}
                    suggestionRender='driver'
                    disable={props.disable}
                    endpoint={ ApiEndpoints.TRANSPORTATION_FLEET_DRIVERS_AUTOCOMPLETE.formattify(props.deliveryServiceCenter) }
                    value={ props.driver ? props.driver.fullName : ''}
                    placeholder="Enter Driver Name"
                />
            </div>
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-3" }>
                <Forms.AutoCompleteInput
                    id="edit-delivery-asset"
                    label="Tractor"
                    onChange={onTractorAssetChange}
                    dispatch={dispatch}
                    suggestionRender={'name'}
                    disable={props.disable}
                    endpoint={ ApiEndpoints.TRANSPORTATION_FLEET_VEHICLE_AUTOCOMPLETE.formattify(props.deliveryServiceCenter) }
                    value={props.tractor ? props.tractor.name : ''}
                    placeholder="Enter Tractor Name"
                />
            </div>
            <div className={ props.showCompactUI ? "col-md-12" : "col-md-3" }>
                <Forms.AutoCompleteInput
                    id="edit-delivery-trailer"
                    label="Trailer"
                    onChange={onTrailerAssetChange}
                    dispatch={dispatch}
                    disable={props.disableTrailer}
                    endpoint={ ApiEndpoints.TRANSPORTATION_FLEET_TRAILER_AUTOCOMPLETE.formattify(props.deliveryServiceCenter) }
                    value={props.trailer ? props.trailer.name : ''}
                    placeholder="Enter Trailer Name"
                />
            </div>
        </div>
    </React.Fragment>;

};
